module.exports = __webpack_public_path__ + "static/media/earthTexture.28183c76.jpeg";